module.exports = __webpack_public_path__ + "img/车衣宝.61506cb7.png";